import React from 'react'

const ViewProperties = () => {
  return (
    <div>ViewProperties</div>
  )
}

export default ViewProperties